import { appInsights } from '../services/ApplicationInsightsService';
import { ILogger } from './ILogger';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

export const applicationInsightsLogger: ILogger = {
    log(message, properties) {
        appInsights.trackTrace({
            severityLevel: SeverityLevel.Information,
            message,
            properties
        });
    },
    warn(message, properties) {
        appInsights.trackTrace({
            severityLevel: SeverityLevel.Warning,
            message,
            properties
        });
    },
    error(message, properties) {
        appInsights.trackTrace({
            severityLevel: SeverityLevel.Error,
            message,
            properties
        });
    }
};
